import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/B2B/B2BModule.tsx");
